import { WithoutSpecialValidation } from "./withoutSpecialValidation";

export class StreetNumberValidation extends WithoutSpecialValidation {
  msgError = "Informe um número válido.";
}
